import { Provider } from "react-redux";
import { store } from "./store/store";
import { IntlProvider } from "react-intl";
import messages_es from "./translations/es.json";
import messages_en from "./translations/en.json";
import { AppRouter } from "./router/AppRouter";
import "./app.scss";

type NestedMessages = { [key: string]: string | NestedMessages };

export const flattenMessages = (nestedMessages: NestedMessages, prefix = ''): { [key: string]: string } => {
  if (nestedMessages == null) {
    return {};
  }
  return Object.keys(nestedMessages).reduce((messages, key) => {
    const value = nestedMessages[key];
    const prefixedKey = prefix ? `${prefix}.${key}` : key;

    if (typeof value === 'string') {
      messages[prefixedKey] = value;
    } else {
      Object.assign(messages, flattenMessages(value, prefixedKey));
    }

    return messages;
  }, {} as { [key: string]: string });
};

const App = () => {
  const currentLocale = navigator.language.split(/[-_]/)[0];
  const messages = currentLocale === "es" ? messages_es : messages_en;

  return (
    <Provider store={store}>
      <IntlProvider locale={currentLocale} messages={flattenMessages(messages)}>
        <AppRouter />
      </IntlProvider>
    </Provider>
  );
};

export default App;
